/**
 * Session for the IIT Foundation portal.
 *
 * Persisted in sessionStorage (per-tab, cleared when the tab closes) — NOT in
 * cookies or localStorage. This keeps the logged-in student available across
 * portal navigation AND across a page refresh within the same tab, so pages like
 * the dashboard and short notes still know the student (and their class) after a
 * reload.
 *
 * Shape: { id, name, grade_id, class, class_num, school, email_mask, token }
 *
 * grade_id (f_registrations.grade_id → f_class.id) is the one content queries
 * key on — it is the same id f_chapter stores as class_id, so short notes send
 * it as the class_id argument. class ('Class 8') and class_num ('8') are labels
 * for display.
 */
const KEY = "foundation_student";

let current = null;

// Rehydrate from sessionStorage on module load (survives refresh in the same tab).
try {
  const raw =
    typeof window !== "undefined" && window.sessionStorage
      ? window.sessionStorage.getItem(KEY)
      : null;
  if (raw) current = JSON.parse(raw);
} catch (e) {
  current = null;
}

export function setFoundationStudent(student) {
  current = student || null;
  try {
    if (typeof window !== "undefined" && window.sessionStorage) {
      if (current) window.sessionStorage.setItem(KEY, JSON.stringify(current));
      else window.sessionStorage.removeItem(KEY);
    }
  } catch (e) {
    /* storage unavailable (private mode / quota) — fall back to in-memory only */
  }
}

export function getFoundationStudent() {
  return current;
}

export function clearFoundationStudent() {
  setFoundationStudent(null);
}
